/**
 * Skeleton — shimmering placeholders that match content shape.
 * Reduced-motion users get a static light-gray block instead of a shimmer.
 */

export function SkeletonLine({
  width = "100%",
  height = 14,
  style,
}: {
  width?: string | number;
  height?: number;
  style?: React.CSSProperties;
}) {
  return <span className="skel" style={{ width, height, ...style }} aria-hidden="true" />;
}

export function SkeletonBlock({
  height = 48,
  radius = 4,
  style,
}: {
  height?: number;
  radius?: number;
  style?: React.CSSProperties;
}) {
  return (
    <div
      className="skel"
      style={{ height, borderRadius: radius, width: "100%", ...style }}
      aria-hidden="true"
    />
  );
}
